import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Guests from './pages/Guests';
import Conversations from './pages/Conversations';
import Rules from './pages/Rules';
import Claims from './pages/Claims';
import Reviews from './pages/Reviews';
import Log from './pages/Log';
import Walter from './pages/Walter';
import Pipeline from './pages/Pipeline';
import Flights from './pages/Flights';
import FlightsConfig from './pages/flights/FlightsConfig';
import KBPage from './pages/KB';
import Settings from './pages/Settings';
import Scoreboard from './pages/intel/Scoreboard';
import Influencers from './pages/intel/Influencers';
import Episodes from './pages/intel/Episodes';
import AllEpisodes from './pages/intel/AllEpisodes';
import Predictions from './pages/intel/Predictions';
import IntelPipeline from './pages/intel/IntelPipeline';
import IntelStats from './pages/intel/Stats';
import IntelClaims from './pages/intel/Claims';
import Painpoints from './pages/painpoints/Painpoints';
import PainpointDetail from './pages/painpoints/PainpointDetail';
import PcMonitorPage from './pages/pcmonitor/PcMonitorPage';
import VideosPage from './pages/videos/VideosPage';
import VideoDetailPage from './pages/videos/VideoDetailPage';
import PaymentsPage from './pages/payments/PaymentsPage';
import PaymentHistoryPage from './pages/payments/PaymentHistoryPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import { IntelDataProvider } from './contexts/IntelDataContext';
import ComponentGallery from './pages/dev/ComponentGallery';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/dev/components" element={<ComponentGallery />} />
        <Route
          path="*"
          element={
            <AuthGate>
              <IntelDataProvider>
                <Routes>
                  <Route element={<Layout />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/guests" element={<Guests />} />
                    <Route path="/conversations" element={<Conversations />} />
                    <Route path="/rules" element={<Rules />} />
                    <Route path="/claims" element={<Claims />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/log" element={<Log />} />
                    <Route path="/walter" element={<Walter />} />
                    <Route path="/pipeline" element={<Pipeline />} />
                    <Route path="/flights" element={<Flights />} />
                  <Route path="/flights/config" element={<FlightsConfig />} />
                    <Route path="/kb" element={<KBPage />} />
                    <Route path="/intel" element={<Scoreboard />} />
                    <Route path="/intel/influencers" element={<Influencers />} />
                    <Route path="/intel/influencers/:id/episodes" element={<Episodes />} />
                    <Route path="/intel/episodes" element={<AllEpisodes />} />
                    <Route path="/intel/predictions" element={<Predictions />} />
                    <Route path="/intel/pipeline" element={<IntelPipeline />} />
                    <Route path="/intel/stats" element={<IntelStats />} />
                    <Route path="/intel/claims" element={<IntelClaims />} />
                    <Route path="/painpoints" element={<Painpoints />} />
                    <Route path="/painpoints/:nicheId" element={<Painpoints />} />
                    <Route path="/painpoints/detail/:id" element={<PainpointDetail />} />
                    <Route path="/pc-monitor" element={<PcMonitorPage />} />
                    <Route path="/videos" element={<VideosPage />} />
                    <Route path="/videos/:stem" element={<VideoDetailPage />} />
                    <Route path="/payments" element={<PaymentsPage />} />
                    <Route path="/payments/history" element={<PaymentHistoryPage />} />
                    <Route path="/invoices" element={<InvoicesPage />} />
                    <Route path="/settings" element={<Settings />} />
                  </Route>
                </Routes>
              </IntelDataProvider>
            </AuthGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
